<div class="customer">
    <div class="customer-name">
        {{ customerDetails().firstName }} {{ customerDetails().lastName }}
    </div>
    @if (customerDetails().email) {
        <div class="customer-contact-details">
            {{ customerDetails().email }}
        </div>
    }
    @if (customerDetails().mobilePhone) {
        <div class="customer-contact-details">
            {{ customerDetails().mobilePhone }}
        </div>
    }
</div>
